<script>
import { modalComputed, modalMethods, workoutComputed } from '@state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...modalComputed,
    ...workoutComputed,
  },
  mounted() {},
  methods: {
    ...modalMethods,
    close() {
      this.$bvModal.hide('workout-error-modal');
    },
  },
};
</script>

<template class="modal-confirmation">
  <b-modal id="workout-error-modal" centered>
    <template v-if="selectedWorkout" slot="modal-title">
      Duplicate Circuit Names
    </template>

    <template v-if="selectedWorkout" slot="default">
      <div>
        <p class="modal-text-main" v-if="duplicateCircuitError">
          Circuit names must be unique. <br />Try renaming
          {{ duplicateCircuitError.circuitLabel }}.
        </p>
      </div>
    </template>

    <template v-if="selectedWorkout" slot="modal-footer">
      <div class="modal-actions-wrapper">
        <BaseButton class="btn-secondary btn-round" @click="close">
          Close
        </BaseButton>
      </div>
    </template>
  </b-modal>
</template>
